<template>
  <q-card style="width: 600px; max-width: 60vw">
    <q-bar class="bg-primary text-white">
      <q-icon name="fas fa-keyboard" />
      <div>
        <small class="q-ml-sm text-size-sm">
         一键模版添加
        </small>
      </div>

      <q-space />

      <q-btn dense flat icon="close" v-close-popup>
        <q-tooltip>关闭</q-tooltip>
      </q-btn>
    </q-bar>

    <q-card-section class="q-pa-sm">
      <div class="row q-gutter-sm q-mb-sm">
        <select_hospInfo
          :dense="true"
          outlined
          class="col-11"
          label="选择机构"
          v-model="HospID"
          v-model:valueCode="HospID"
        />
        
      </div>
    </q-card-section>

    <q-card-actions align="right" class="bg-white text-teal">
      <q-btn flat label="取消" v-close-popup />
      <q-btn flat label="确定" @click="onOK" />
    </q-card-actions>
  </q-card>
</template>

<script>
import { mapActions, mapState } from "vuex";
import select_hospInfo from "@/views/pdm/comm/hospInfo_select.vue";
import * as ConfigValues from "@/api/pdm/configValues";
export default {
  components: {
    select_hospInfo,
  },
  props: {},
  computed: {
    ...mapState("PdmConfigValues", [
      "PdmConfigValuesShowDlg",
      "PdmConfigValuesEntity",
      "PdmConfigValuesList",
    ]),
  },
  data() {
    return {
      HospID:null,
    };
  },
  mounted() {},
  methods: {
    ...mapActions("PdmConfigValues", [
      "actUpdatePdmConfigValues",
      "actGetPdmConfigValuesList",
    ]),
    onOK() {
      ConfigValues.UpdatePDM_CONFIG_VALUESlist({
        HospID: this.HospID,
      }).then((res) => {
        if (res.Code == 0) {
          this.$store.commit("PdmConfigValues/setPdmConfigValuesShowDlg2", false);
          this.$store.commit("WebConfig/setWebConfigState", 1);
          this.$emit("onLoadData");
          this.msg.success(res.Message);
        } else {
          this.msg.error(res.Message);
        }
      });
    },
  },
};
</script>
